import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode } from '@fortawesome/free-solid-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faFlickr } from '@fortawesome/free-brands-svg-icons';
import { faCopyright } from '@fortawesome/free-regular-svg-icons';

import './Footer.scss';

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer__information">
        <FontAwesomeIcon icon={faCode} size="2xl" />
        <p>
          <FontAwesomeIcon icon={faCopyright} />
          <span>Gaëtan TREMOIS | 2024</span>
        </p>
      </div>
      <div className="footer__links">
        <Link
          aria-label="Vers le page GitHub de Gaëtan TREMOIS"
          to="https://github.com/gtcore902"
        >
          <FontAwesomeIcon icon={faGithub} size="xl" />
        </Link>
        <Link
          aria-label="Vers la page Linkedin de Gaëtan TREMOIS"
          to="https://www.linkedin.com/in/ga%C3%ABtan-tremois-a956a91a3/"
        >
          <FontAwesomeIcon icon={faLinkedin} size="xl" />
        </Link>
        <Link
          aria-label="Vers la page Flickr de Gaëtan TREMOIS"
          to="https://www.flickr.com/photos/186142483@N06/"
        >
          <FontAwesomeIcon icon={faFlickr} size="xl" />
        </Link>
      </div>
    </div>
  );
};

export default Footer;
